import { Component, Input } from '@angular/core';
import { CvConfigurationService } from 'src/app/reusables/services/cv-configuration.service';
import { ModuleManager } from 'src/shared/models/module-manager';

@Component({
    selector: 'cv-expanded-summary',
    templateUrl: './expanded-summary.component.html',
    styleUrls: ['./expanded-summary.component.scss']
})
export class ExpandedSummaryComponent {
    @Input() moduleManager: ModuleManager;
    @Input() moduleKey: string;

    constructor(
        private config: CvConfigurationService,
    ) { }

    public get isCXOne() { return this.config.isCxOne; }

}
